<template>
    <div class="container-fluid">
        <div class="page-container">
            <div class="form-image-container">
                <div class="form-container">
                    <a href="/"><img src="../assets/logo/appLogo.svg" alt=""></a>
                    <h2 class="form-title">Almost There!</h2>
    
                    <p>We've sent a one-time password (OTP) to your email. Enter it below to continue.</p>
                    
                    <!-- otp -->
                    <div class="otp-container">
                    <input 
                        v-for="(digit, index) in otp" 
                        :key="index"
                        type="text"
                        maxlength="1"
                        class="otp-input"
                        v-model="otp[index]"
                        @input="moveToNext(index)"
                        @keydown.backspace="moveToPrev(index)"
                    />
                   </div>
    
                    <button class="recover-password" @click="resetPassword">Didn't receive the code? Resend OTP</button>
                    <!-- Submit -->
                    <button class="submit-btn" @click="handleContinue" :disabled="isSubmitButtonDisabled" v-if="!loading">Continue</button>
                    <button class="submit-btn" type="button" v-if="loading">
                        <i class="fas fa-spinner fa-spin"></i>
                    </button>
                    
                    <div class="login-info">
                        <!-- <p>Make sure you entered the correct phone number or email
                            If you didn't change HERE</p> -->
                    </div>
                  
                </div>
                <div class="image-container">
                    <div class="logo">
                        <img src="../assets/logo/appLogo.svg" alt="">
                    </div>
                    <h2>“Courts are immaculate, coaching is world‑class, and the community is genuinely welcoming.”</h2>
                    <p>— Fatima R.</p>
                    <span>Member since 2018</span>
                    <img src="../assets/images/login/9510e57c6431aad56325e43504a50028314cd441.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script setup>
/* eslint-disable */
import { ref, computed } from "vue";
import router from "@/router";
import axios from 'axios';

const otp = ref(["", "", "", ""]);
let username = ref('');
let loading = ref(false);

const moveToNext = (index) => {
  if (otp.value[index].length === 1 && index < 3) {
    const next = document.querySelectorAll(".otp-input")[index + 1];
    next.focus();
  }
};

const moveToPrev = (index) => {
  if (otp.value[index] === "" && index > 0) {
    const prev = document.querySelectorAll(".otp-input")[index - 1];
    prev.focus();
  }
};

const isSubmitButtonDisabled = computed(() => {
  return otp.value.join("").length !== 4 || loading.value;
});

const resetPassword = () => {
  router.push('/reset-password');
};

const handleContinue = async () => {
  const otpCode = otp.value.join("");

  if (otpCode.length !== 4) {
    alert("Please enter the 4-digit OTP");
    return;
  }

  try {
    loading.value = true;

    const response = await axios.post('/validate_otp.php', {
      otp: otpCode,
    });

    loading.value = false;

    if (response.data.status === true) {
      router.push(`/create-password/${response.data.ref}`);
    } else {
      alert(response.data.message);
    }

  } catch (error) {
    loading.value = false;
    alert(error.response ? error.response.data.message : error.message);
  }
};
</script>

    
    <style lang="scss" scoped>
    .otp-container {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin: 15px 0;
    }

    .otp-input {
        width: 50px;
        height: 50px;
        font-size: 22px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 6px;
    }
    @media (max-width: 768px) {
        .otp-input {
        width: 60px;
        height: 60px;
        font-size: 22px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 6px;
    }

    }
    .page-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        background-color: #F6F6F6;
        gap: 2rem;
        margin: auto;
    
        .form-image-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            //align-items: center;
            margin: auto;
            min-height: 100vh;
    
            .form-container {
                width: 40%;
                padding-left: 140px;
                padding-top: 120px;
    
            }
                
                .form-title {
                    text-align: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    font-size: 24px;
                    color: #000000;
                    font-weight: 700;
                    font-family: "Open Runde", sans-serif;
                }
    
                p {
                    text-align: center;
                    margin-bottom: 20px;
                    color: #707B81;
                    font-size: 16px;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                }
    
                .form-group {
                    margin-bottom: 10px;
                    display: flex;
                    flex-direction: column;
                }
    
                .form-group:last-of-type {
                    margin-bottom: 5px;
                }
    
                label {
                    margin-bottom: 6px;
                    font-weight: 500;
                    font-size: 15px;
                    color: #30373D;
                    text-align: left;
                    width: 100%;
                }
    
                input {
                    padding: 10px 20px;
                    border: 1px solid #D1D1D1;
                    border-radius: 14px;
                    font-size: 16px;
                }
    
                input:focus {
                    border-color: #4a90e2;
                    outline: none;
                }
    
                .password-wrapper {
                    display: flex;
                    align-items: center;
                    position: relative;
                }
    
                .password-wrapper input {
                    flex: 1;
                    padding-right: 60px;
                }
    
                .toggle-btn {
                    position: absolute;
                    right: 10px;
                    background: none;
                    border: none;
                    font-size: 13px;
                    color: #4a90e2;
                    cursor: pointer;
                }
    
                .toggle-btn:hover {
                    text-decoration: underline;
                }
    
                .recover-password {
                    background: none;
                    border: none;
                    color: #333;
                    font-size: 14px;
                    text-align: right;
                    margin-bottom: 2rem;
                    width: 100%;
                }
    
                .submit-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: #ED4E24;
                    border: 1px solid #eb7758;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    cursor: pointer;
                    transition: background 0.3s ease;
                }
    
                .register-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: white;
                    border: 1px solid #00000033;
                    color: #000000CC;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    cursor: pointer;
                    margin-top: 0.2rem;
                    transition: background 0.3s ease;
                    margin-bottom: 6.2rem;
                }
    
                .submit-btn:hover {
                    background: #eb7758;
                }
    
                .login-info {
                    display: flex;
                    justify-content: center;
                    align-items: center  ;
                    gap: 20px;
                    margin-top: 30px;
    
                    p {
                        font-size: 14px;
                        color: #555555;
                        font-weight: 400;
                        font-family: "Open Runde", sans-serif;
                        max-width: 80%;
                        text-align: left;
                    }
                }
        }
    
            .image-container {
                width: 50%;
                position: relative;
                padding-top: 20px;
                padding-bottom: 20px;
                
            }
    
            .logo {
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 1;
            }
    
            .logo img {
                max-height: 45px;
            }
    
            .image-container img {
                width: 100%;
                height: 100%;
                border-radius: 16px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                /* filter: blur(4px); */
                position: relative;
                z-index: 0;
                /* 👈 send behind */
            }
    
            .image-container h2,
            .image-container p,
            .image-container span {
                position: absolute;
                z-index: 1;
                /* 👈 bring forward */
                font-family: "Open Runde", sans-serif;
                color: #fff;
            }
    
            .image-container h2 {
                bottom: 30px;
                left: 45%;
                font-size: 28px;
                font-weight: 500;
                transform: translate(-50%, -50%);
                text-align: left;
                width: 80%;
            }
    
            .image-container p {
                bottom: 20px;
                left: 45%;
                font-size: 14px;
                font-weight: 400;
                transform: translate(-50%, -50%);
                text-align: left;
                width: 80%;
            }
    
            .image-container span {
                bottom: 18px;
                left: 45%;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFFCC;
                transform: translate(-50%, -50%);
                text-align: left;
                width: 80%;
            }
    
        }
    
    @media (max-width: 768px) {
        .page-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: 100%;
            background-color: #F6F6F6;
            gap: 2rem;
            margin: auto;
            padding: 20px 10px 20px 10px;
    
            .form-image-container {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: auto;
    
                .form-container {
                    width: 100%;
                    padding-left: 0px;
                    padding-top: 80px;
    
                    .form-title {
                        text-align: center;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-size: 20px;
                        color: #000000;
                        font-weight: 700;
                        font-family: "Open Runde", sans-serif;
                    }
    
                    p {
                        text-align: center;
                        margin-bottom: 10px;
                        color: #707B81;
                        font-size: 16px;
                        font-weight: 400;
                        font-family: "Open Runde", sans-serif;
                    }
    
                    .form-group {
                        margin-bottom: 10px;
                        display: flex;
                        flex-direction: column;
                    }
    
                    .form-group:last-of-type {
                        margin-bottom: 5px;
                    }
    
                    label {
                        margin-bottom: 6px;
                        font-weight: 500;
                        font-size: 15px;
                        color: #30373D;
                        text-align: left;
                        width: 100%;
                    }
    
                    input {
                        padding: 12px 24px;
                        border: 1px solid #D1D1D1;
                        border-radius: 14px;
                        font-size: 16px;
                    }
    
                    input:focus {
                        border-color: #4a90e2;
                        outline: none;
                    }
    
                    .password-wrapper {
                        display: flex;
                        align-items: center;
                        position: relative;
                    }
    
                    .password-wrapper input {
                        flex: 1;
                        padding-right: 60px;
                    }
    
                    .toggle-btn {
                        position: absolute;
                        right: 10px;
                        background: none;
                        border: none;
                        font-size: 13px;
                        color: #4a90e2;
                        cursor: pointer;
                    }
    
                    .toggle-btn:hover {
                        text-decoration: underline;
                    }
    
                    .recover-password {
                        background-color: none;
                        border: none;
                        color: #4a90e2;
                        font-size: 14px;
                        text-align: right;
                        margin-bottom: 2rem;
                        width: 100%;
                    }
    
                    .submit-btn {
                        width: 100%;
                        padding: 14px 12px;
                        background: #ED4E24;
                        border: 1px solid #eb7758;
                        color: #fff;
                        font-size: 16px;
                        font-weight: 600;
                        border-radius: 60px;
                        cursor: pointer;
                        transition: background 0.3s ease;
                    }
    
                    .register-btn {
                        width: 100%;
                        padding: 14px 12px;
                        background: white;
                        border: 2px solid #00000033;
                        color: #000000CC;
                        font-size: 16px;
                        font-weight: 600;
                        border-radius: 60px;
                        cursor: pointer;
                        margin-top: 10px;
                        transition: background 0.3s ease;
                    }
    
                    .submit-btn:hover {
                        background: #eb7758;
                    }
    
                    .login-info {
                        display: flex;
                        justify-content: start;
                        align-items: start;
                        gap: 20px;
                        margin-top: 30px;
    
                        p {
                            font-size: 14px;
                            color: #555555;
                            font-weight: 400;
                            font-family: "Open Runde", sans-serif;
                            max-width: 80%;
                            text-align: left;
                        }
                    }
                }
    
                .image-container {
                    display: none;
                }
            }
    
    
        }
    }
    </style>
    